module.exports = __webpack_public_path__ + "img/b4-1.57e265d.png";